import React, { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api } from "@/redux/api";
import ServiceRequestDetail from "@/containers/service-request/ServiceRequestDetail";

export default function TenantServiceRequestDetailPage() {
  const { id } = useParams();
  const location = useLocation();

  const listPath = `/tennant/service-request${location.search || ""}`;

  const loadRequest = useCallback(
    (requestId) => api.getTenantServiceRequest(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addTenantServiceRequestNote(requestId, content),
    []
  );

  return (
    <ServiceRequestDetail
      role="tenant"
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote
      closeRequest={api.closeTenantServiceRequest}
      reopenRequest={api.reopenTenantServiceRequest}
      respondCost={api.respondTenantServiceRequestCost}
    />
  );
}
